<template>
  <div class="order-wrapper payment-wrapper"
    v-bind:class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="Menu"
        :buttonsList="getReportButtons"
        :selectedCategory="selectedCategory"
        :noSearchFilter="true"
        v-on:generateReport="generateReport"/>
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div class="content">
          <Header />
          <List v-on:ShowDetail='ShowDetail'/>
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          v-if="!transporterLoading"
          :selectedFilters="filterConstant"
          :filters="filters"
          v-on:search="applyFilters"
          v-on:updateOption = "updateOption"
          v-on:reset = "resetApply"
          v-on:clearDate = "clearDate"/>
      </div>
    </div>
    <Drawer
      :visible.sync="elDrawer"
      direction="rtl"
      size="800px"
      :modal="true"
      :withHeader="false"
      :append-to-body="true"
      :before-close="closeDrawer"
      class="default-drawer">
      <Link :underline="false" class="nav-close" @click="elDrawer=false">
        <svgicon name="cancelwhite" width="12" height="12" :original="true" />
      </Link>
      <div>
        <div class="drawer-header px-15">
          GI-EX-1010A-M-50
          <div class="header-action">
            <span>
              <Button type="text" size="small" class="button-link">
                <svgicon name="icon-edit" width="8" height="8" />
                <span>Edit</span>
              </Button>
              <Button type="text" size="small" class="button-link" @click="elDrawer=false">
                <svgicon name="icon-close" width="8" height="8" />
                <span>Cancel</span>
              </Button>
            </span>
          </div>
        </div>
        <div class="drawer-body p-0">
          <ElTabs class="tab-default tab-sm tab-bg">
            <Tab-pane label="Details">
              <div class="tab-content">
                <div class="flex-container panel-head align-top">
                  <div class="flex-item">
                    <p>
                      Source : <strong>Chennai Port</strong>
                    </p>
                    <p>
                      Indent Created Date : <strong>10 June 2020 </strong>
                    </p>
                  </div>
                  <div class="flex-item text-right">
                    <p>
                      Destination : <strong>Camions Goods Pvt Ltd </strong>
                    </p>
                    <p>
                      Incoterms : <strong>FOB </strong>
                    </p>
                  </div>
                </div>
                <Table
                  :data="tableData"
                  :stripe="true"
                  align="top"
                  class="table-striped bordered my-15"
                  max-height="250px"
                  aria-describedby="eximListTableData"
                  >
                  <TableColumn pro="freight" label="Freight Forwarder" width="200">
                    <template slot-scope="scope">
                      <span>
                        <span class="d-block">Krishna Freight Forwarder</span>
                      </span>
                    </template>
                  </TableColumn>
                  <TableColumn pro="bookingno" label="Container Booking No." width="160">
                    <template slot-scope="scope">
                      92345
                    </template>
                  </TableColumn>
                  <TableColumn prop="expecteddate" label="Expected Delivery Date" width="180">
                    <template slot-scope="scope">
                      11 June 2020
                    </template>
                  </TableColumn>
                  <TableColumn prop="expectedvessel" label="Expected Vessel Sailing Date">
                    <template slot-scope="scope">
                      12 June 2020
                    </template>
                  </TableColumn>
                </Table>
                <Collapse v-model="activeName" accordion class="collapse-slider mx-15">
                  <CollapseItem title="Road leg">
                    <div class="flex-container panel-head align-top">
                        <div class="flex-item">
                          <p>
                            Source : <strong>Chennai Port</strong>
                          </p>
                          <p>
                            Vehicle Requirement Date : <strong>10 June 2020</strong>
                          </p>
                        </div>
                        <div class="flex-item text-right">
                          <p>
                            Destination : <strong>Camions Goods Pvt Ltd</strong>
                          </p>
                          <p>
                            Expected Delivery Date : <strong>10 June 2020</strong>
                          </p>
                        </div>
                    </div>
                    <div class="flex-container panel-head align-top mt-10">
                      <div class="flex-item">
                        <p>
                          <strong class="text-blue-dark1">GI-49-RI-A</strong>
                        </p>
                      </div>
                      <div class="flex-item text-right">
                        <p>
                          Base Freight : <strong class="text-green-medium">1000 / per trip</strong>
                        </p>
                      </div>
                    </div>
                    <Table
                      :data="tableData1"
                      :stripe="true"
                      align="top"
                      class="table-striped bordered my-15"
                      max-height="250px"
                      aria-describedby="eximListTableData1"
                      >
                      <TableColumn pro="vehicletype" label="Transporter & vehicle Type" width="200">
                        <template slot-scope="scope">
                          <span>
                            <span class="d-block">Krishna Freight Forwarder</span>
                            <span class="text-xs">240FT Trailer</span>
                          </span>
                        </template>
                      </TableColumn>
                      <TableColumn pro="pickups" label="Pickups" width="140">
                        <template slot-scope="scope">
                          North Main Gate
                        </template>
                      </TableColumn>
                      <TableColumn prop="containertype" label="Container Type & Number" width="180">
                        <template slot-scope="scope">
                          <span>
                            <span class="d-block">Double Door</span>
                            <span class="text-xs">98567</span>
                          </span>
                        </template>
                      </TableColumn>
                      <TableColumn prop="shippingno" label="Shipping Bill No." width="150">
                        <template slot-scope="scope">
                          3455
                        </template>
                      </TableColumn>
                      <TableColumn prop="sealno" label="Line Seal No.">
                        <template slot-scope="scope">
                          98654
                        </template>
                      </TableColumn>
                    </Table>
                  </CollapseItem>
                </Collapse>
              </div>
            </Tab-pane>

            <Tab-pane label="Timeline">
              <div class="tab-content timeline-multi">
                <Timeline />
              </div>
            </Tab-pane>

            <Tab-pane label="Attachments">
              <div class="tab-content">
                <!-- <div class="status-msg my-md">
                  <span>
                    <svgicon name="empty-timeline" width="180" height="130" :original="true" />
                    <p class="ml-30">No data found</p>
                  </span>
                </div> -->
                <ul class="list-attachment list-multi">
                  <li>
                    <label>Packing List</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                  <li>
                    <label>Insurance Certificate</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                  <li>
                    <label>Country of Origin Certificate</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                  <li>
                    <label>Industrial License</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                  <li>
                    <label>Technical Specs Document</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                  <li>
                    <label>Miscellaneous</label>
                    <span class="action-attach">
                      <svgicon name="add-grey" width="12" height="12" :original="true" />
                    </span>
                  </li>
                </ul>
              </div>
            </Tab-pane>
          </ElTabs>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { Menu, reportButtons, reports, filters } from '@/constants/reportConstants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import Header from '@common/components/eximlist/list/Header';
import List from '@common/components/eximlist/list/Row';
import Timeline from '@common/components/eximlist/Timeline';
import moment from 'moment';

export default {
  components: {
    PrimaryFilter,
    SecFilter,
    FilterWrapper,
    Header,
    List,
    Timeline,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      openSlideleft: true,
      defaultValues: {},
      dateFilterError: false,
      Menu,
      reportButtons,
      transporters: [],
      transporterLoading: false,
      transporterList: [],
      selectedReport: 0,
      reports,
      filterConstant: [],
      filters,
      elDrawer: false,
      closeDrawer: true,
      tableData: [{
        freight: 'Krishna Freight Forwarder',
      }, {
        freight: 'Krishna Freight Forwarder',
      }],
      tableData1: [{
        vehicletype: 'Krishna Freight Forwarder',
      }, {
        vehicletype: 'Krishna Freight Forwarder',
      }],
    };
  },
  async created() {
    this.transporterLoading = true;
    const list = await this.$store.dispatch('dashboard/transporterlist');
    if (list) {
      list.unshift({ id: -1, name: 'All Transporters' });
      this.transporterList = list;
    }
    this.transporterLoading = false;
    this.setDefaults();
    this.constructConstantForFilter();
    this.applyFilters();
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
    }),
    selectedCategory() {
      return this.Menu[0];
    },
    isDepotSet() {
      const depot = this.findByCategory(this.filters.DEPOT);
      return depot && (depot.length != 0);
    },
    isTransporterSet() {
      const transporter = this.findByCategory(this.filters.TRANSPORTER);
      return transporter && (transporter.id != 0);
    },
    getDateFilterError() {
      const dateFilter = this.findByCategory(this.filters.DATE);
      const selectedFilter = ['Optima Variance', 'Optima Variance Summary', 'Overage, Shortage and Damage Report'];
      if (this.selectedReport && (selectedFilter.includes(this.reports[this.selectedReport - 1].name)) && dateFilter.startDate !== dateFilter.endDate) {
        this.dateFilterError = true;
      } else {
        this.dateFilterError = false;
      }
      return this.dateFilterError;
    },
    getReportButtons() {
      const buttonList = this.reportButtons;
      const buttonIndex = this.reportButtons.findIndex(button => button.name === 'Generate Report');
      if (this.dateFilterError || (this.selectedReport === 0)) {
        buttonList[buttonIndex].disabled = true;
      } else {
        buttonList[buttonIndex].disabled = false;
      }
      return buttonList;
    },
    filterParams() {
      return this.filterConstant && this.filterConstant.flat();
    },
  },
  methods: {
    ShowDetail() {
      this.elDrawer = true;
    },
    setDefaults() {
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0]);
      [this.defaultValues.transporter] = this.transporterList;
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(89, 'days').toString();
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'MultiSelectList',
            category: this.filters.DEPOT,
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: this.depots,
            idLabel: 'id',
            optional: false,
            clearSelected: true,
            selectAllOption: true,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
          },
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: false,
            maxDays: 366,
          },
          {
            type: 'List',
            category: this.filters.TRANSPORTER,
            default: this.defaultValues.transporter,
            selected: this.defaultValues.transporter,
            list: this.transporterList,
            idLabel: 'id',
            queryParamString: 'transporter_id',
            optional: false,
          },
        ],
      ];
    },
    reportChange(reportRadio) {
      this.selectedReport = reportRadio;
    },
    constructParams() {
      if (this.selectedReport) {
        let params = null;
        params = this.constructFilterPayload();
        if (params && params.error) {
          this.$errorMessage({ message: params.error });
          return null;
        }
        const selectedReports = ['Optima Variance', 'Optima Variance Summary', 'Overage, Shortage and Damage Report'];
        if (selectedReports.includes(this.reports[this.selectedReport - 1].name)) {
          params = Object.assign(params, { date: params.start });
          delete params.start;
          delete params.end;
        } else if (this.reports[this.selectedReport - 1].name === 'Primary Delay') {
          params = Object.assign(params, { depot_type: 1 });
        } else if (this.reports[this.selectedReport - 1].name === 'Secondary Delay') {
          params = Object.assign(params, { depot_type: 2 });
        }
        return params;
      }
    },
    async generateReport() {
      const params = this.constructParams();
      if (params) {
        const data = { report: this.reports[this.selectedReport - 1], params };
        let result;
        result = await this.$store.dispatch(`report/${this.reports[this.selectedReport - 1].emitMethod}`, data);
        if (result.data) {
          this.$successMessage({ message: result.data.message });
        }
      }
    },
    resetApply() {
      this.resetAll();
      this.applyFilters();
    },
  },
};
</script>
